import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Avatar } from '../avatar/avatar.component';

type PersonShape = {
  id: number;
  avatarUrl: string | null;
  name: string | null;
  isCurrentUser?: boolean;
};

export enum TestIds {
  Name = 'name',
}

@Component({
  selector: 'procure-person',
  templateUrl: './person.component.html',
  styleUrl: './person.component.scss',
  imports: [Avatar],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Person {
  readonly user = input<PersonShape | null>();

  protected readonly TestIds = TestIds;
}
